import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { isEmptyArray } from 'utils';
import { withRouter } from 'react-router-dom';
import Util from 'screens/shared/utilities';
import CommonSelector from './common-selector';

export default withRouter(({
  onChange = null, value = '', type = 'CDROM', isOpen = false, locationId, error,
}) => {
  let { [ACTIONS_TYPES.IMAGES.GET_ALL]: images = [] } = useSelector((e) => e);

  useEffect(() => {
    if (isEmptyArray(images)) actions.images.getAll();
    // eslint-disable-next-line
  }, []);

  if (type === 'CDROM') images = images.filter((e) => e.imageType === 'CDROM');
  else images = images.filter((e) => e.imageType !== 'CDROM');

  if (locationId) images = images.filter((e) => e.location === locationId);

  return (
    <CommonSelector
      title="Select an Image"
      itemIcon="compact-disc"
      setItemTitle={(e) => e?.name}
      setItemDetails={(e) => <Util.DetailsLine object={{ OS: e.licenceType, Size: `${e.size}GB`, Owner: e.type }} />}
      items={images}
      onChange={onChange}
      returnValuePropOnly={false}
      value={value.id}
      valuePropName="id"
      error={error}
      isFilter
      isCollapsed={!isOpen}
      filterByPropName="name"
    />
  );
});
